import { Table } from 'lucide-react';
import type { TableStatus } from '../types';
import { getRelativeTime, getFullDateTime } from '../utils/formatting';
import { StatusBadge } from './StatusBadge';

interface TableRowProps {
  table: TableStatus;
}

export function TableRow({ table }: TableRowProps) {
  const errorText = table.error_message || '';
  const truncatedError =
    errorText.length > 80 ? `${errorText.slice(0, 80)}...` : errorText;

  return (
    <tr className="border-t border-gray-800/50 bg-gray-950/40 hover:bg-gray-900/60 transition-colors duration-100">
      {/* Table name */}
      <td className="px-4 py-3 pl-12">
        <div className="flex items-center gap-2">
          <Table className="w-3.5 h-3.5 text-gray-500 flex-shrink-0" />
          <span className="text-sm text-gray-300">{table.name}</span>
        </div>
      </td>

      {/* Schema */}
      <td className="px-4 py-3">
        <span className="text-sm text-gray-400">{table.schema}</span>
      </td>

      {/* Rows */}
      <td className="px-4 py-3 text-right">
        <span className="text-sm text-gray-300 tabular-nums">
          {table.rows_formatted}
        </span>
      </td>

      {/* Size */}
      <td className="px-4 py-3 text-right">
        <span className="text-sm text-gray-300 tabular-nums">
          {table.size_mb_formatted}
        </span>
      </td>

      {/* Status */}
      <td className="px-4 py-3">
        <StatusBadge status={table.status} />
      </td>

      {/* Last Sync */}
      <td className="px-4 py-3">
        <span
          className="text-sm text-gray-400"
          title={getFullDateTime(table.lastSyncDateTime)}
        >
          {getRelativeTime(table.lastSyncDateTime)}
        </span>
      </td>

      {/* Error */}
      <td className="px-4 py-3 max-w-[200px]">
        {errorText ? (
          <span
            className="text-sm text-red-400 truncate block"
            title={errorText}
          >
            {truncatedError}
          </span>
        ) : (
          <span className="text-sm text-gray-600">&mdash;</span>
        )}
      </td>
    </tr>
  );
}
